module.exports = __webpack_public_path__ + "img/image.d0eebcfa.svg";